import React, { useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import { Check, ArrowRight, Compass } from 'react-feather';

const STEPS = [
  { key: 'add_sites',    label: 'Add sites to crawl',          path: (org) => org && `/organizations/${org}/sites/new` },
  { key: 'invite_users', label: 'Invite users to your account',path: (org) => org && `/organizations/${org}/manage_users` },
  { key: 'check_api',    label: 'Check the API documentation', path: (org) => org && `/organizations/${org}/api_details` },
  { key: 'setup_api',    label: 'Set up API download',         path: (org) => org && `/organizations/${org}/api_details` },
  { key: 'faq',          label: 'Read the FAQ',                href: 'https://www.promptcloud.com/web-data-scraping-faqs-promptcloud/' },
];

export default function GettingStartedCard({ org_identifier }) {
  const [done, setDone] = useState({});

  const toggle = (key) => setDone((d) => ({ ...d, [key]: !d[key] }));
  const completed = STEPS.filter((s) => done[s.key]).length;
  const pct = Math.round((completed / STEPS.length) * 100);

  return (
    <Card className='shadow-sm border-0 h-100'>
      <CardBody style={{ padding: 24 }}>
        <div className='d-flex align-items-start mb-3'>
          <div
            className='d-inline-flex align-items-center justify-content-center me-3 flex-shrink-0'
            style={{ width: 40, height: 40, borderRadius: 10, background: '#0d6efd15', color: '#0d6efd' }}
          >
            <Compass size={20} />
          </div>
          <div>
            <h6 className='fw-semibold mb-1 text-dark' style={{ fontSize: 16 }}>
              Getting started
            </h6>
            <p className='text-muted mb-0' style={{ fontSize: 13 }}>
              Quick steps to get the most out of CrawlBoard.
            </p>
          </div>
        </div>

        {/* Progress bar */}
        <div className='mb-3'>
          <div className='d-flex justify-content-between mb-1'>
            <span className='text-muted' style={{ fontSize: 12, fontWeight: 500 }}>
              {completed} of {STEPS.length} done
            </span>
            <span className='text-dark' style={{ fontSize: 12, fontWeight: 600 }}>{pct}%</span>
          </div>
          <div style={{ height: 6, background: '#e9ecef', borderRadius: 3, overflow: 'hidden' }}>
            <div
              style={{
                width: `${pct}%`,
                height: '100%',
                background: 'linear-gradient(90deg, #0d6efd, #6610f2)',
                transition: 'width 200ms ease',
              }}
            />
          </div>
        </div>

        {/* Step list */}
        <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
          {STEPS.map((step) => {
            const isDone = !!done[step.key];
            const targetHref = step.href || step.path?.(org_identifier);
            return (
              <li key={step.key} className='d-flex align-items-center py-2' style={{ borderBottom: '1px solid #f1f3f5' }}>
                <button
                  type='button'
                  onClick={() => toggle(step.key)}
                  className='d-inline-flex align-items-center justify-content-center me-3 flex-shrink-0'
                  style={{
                    width: 22,
                    height: 22,
                    borderRadius: '50%',
                    border: isDone ? '0' : '1.5px solid #ced4da',
                    background: isDone ? '#198754' : '#fff',
                    color: '#fff',
                    cursor: 'pointer',
                    padding: 0,
                  }}
                  aria-label={isDone ? 'Mark as not done' : 'Mark as done'}
                >
                  {isDone && <Check size={14} strokeWidth={3} />}
                </button>
                <span
                  style={{
                    fontSize: 13,
                    flex: 1,
                    color: isDone ? '#adb5bd' : '#212529',
                    textDecoration: isDone ? 'line-through' : 'none',
                  }}
                >
                  {step.label}
                </span>
                {targetHref && !isDone && (
                  <a
                    href={targetHref}
                    target={step.href ? '_blank' : undefined}
                    rel={step.href ? 'noreferrer' : undefined}
                    className='text-decoration-none'
                    style={{ color: '#0d6efd' }}
                    aria-label={`Go to ${step.label}`}
                  >
                    <ArrowRight size={14} />
                  </a>
                )}
              </li>
            );
          })}
        </ul>
      </CardBody>
    </Card>
  );
}
